import {mapActions, mapState} from "vuex";

export default {
    methods: {
        ...mapActions(['TIMER_MODAL']),
        openModalResult(title, text) {
            this.MODAL({
                name: 'ModalResult',
                title: title,
                info: {
                    text: text
                },
            })
        },
        openModalResultDefault(title, text) {
                this.MODAL(null)
                let timerResult = setTimeout(() => {
                    this.openModalResult(title, text);
                }, 500)
                this.TIMER_MODAL(timerResult)
        },


        openModalCropImg(fileOut, fileOutSrc) {
            this.MODAL({
                name: 'ModalCropImg',
                info: {
                    fileOut, fileOutSrc
                },
                onComplete: ({ file, fileSrc }) => {
                   this.cropImg(file, fileSrc);
                },
            })
        },
        openModalTags(tag) {
            this.MODAL({
                name: 'ModalTags',
                title: tag ? 'Редактировать тег' : 'Создать тег',
                info: {
                    tag
                },
                onComplete: (tag) => {
                    this.addTag(tag);
                },
            })
        },
    }
}